/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ClaimContact,
  ClaimContactsResponse,
  ClaimDetailed,
  ClaimListResponse,
  ClaimOrganization,
  ClaimOrganizationsResponse,
  ClaimPropertiesResponse,
  ClaimProperty,
  ClaimStats,
  ClaimStatusTemplateListResponse,
  ClaimWidget,
  Contact,
  CreateClaimRequest,
  CreateClaimWidgetRequest,
  ErrorEnvelope,
  GetAssignableUsers200Response,
  GetClaimAssignees200Response,
  GetClaimShares200Response,
  GetSharedClaimFilterOptions200Response,
  LinkClaimContactRequest,
  LinkClaimOrganizationRequest,
  LinkClaimPropertyRequest,
  ListClaimWidgets200Response,
  Organization,
  Problem,
  Property,
  RespondToAppraisal201Response,
  RespondToAppraisalRequest,
  ShareClaimRequest,
  ShareClaimResponse,
  UpdateClaimAccess200Response,
  UpdateClaimAccessRequest,
  UpdateClaimRequest,
  WidgetPublicConfig,
  WidgetSubmitRequest,
  WidgetSubmitResponse,
} from '../models/index';
import {
    ClaimContactFromJSON,
    ClaimContactToJSON,
    ClaimContactsResponseFromJSON,
    ClaimContactsResponseToJSON,
    ClaimDetailedFromJSON,
    ClaimDetailedToJSON,
    ClaimListResponseFromJSON,
    ClaimListResponseToJSON,
    ClaimOrganizationFromJSON,
    ClaimOrganizationToJSON,
    ClaimOrganizationsResponseFromJSON,
    ClaimOrganizationsResponseToJSON,
    ClaimPropertiesResponseFromJSON,
    ClaimPropertiesResponseToJSON,
    ClaimPropertyFromJSON,
    ClaimPropertyToJSON,
    ClaimStatsFromJSON,
    ClaimStatsToJSON,
    ClaimStatusTemplateListResponseFromJSON,
    ClaimStatusTemplateListResponseToJSON,
    ClaimWidgetFromJSON,
    ClaimWidgetToJSON,
    ContactFromJSON,
    ContactToJSON,
    CreateClaimRequestFromJSON,
    CreateClaimRequestToJSON,
    CreateClaimWidgetRequestFromJSON,
    CreateClaimWidgetRequestToJSON,
    ErrorEnvelopeFromJSON,
    ErrorEnvelopeToJSON,
    GetAssignableUsers200ResponseFromJSON,
    GetAssignableUsers200ResponseToJSON,
    GetClaimAssignees200ResponseFromJSON,
    GetClaimAssignees200ResponseToJSON,
    GetClaimShares200ResponseFromJSON,
    GetClaimShares200ResponseToJSON,
    GetSharedClaimFilterOptions200ResponseFromJSON,
    GetSharedClaimFilterOptions200ResponseToJSON,
    LinkClaimContactRequestFromJSON,
    LinkClaimContactRequestToJSON,
    LinkClaimOrganizationRequestFromJSON,
    LinkClaimOrganizationRequestToJSON,
    LinkClaimPropertyRequestFromJSON,
    LinkClaimPropertyRequestToJSON,
    ListClaimWidgets200ResponseFromJSON,
    ListClaimWidgets200ResponseToJSON,
    OrganizationFromJSON,
    OrganizationToJSON,
    ProblemFromJSON,
    ProblemToJSON,
    PropertyFromJSON,
    PropertyToJSON,
    RespondToAppraisal201ResponseFromJSON,
    RespondToAppraisal201ResponseToJSON,
    RespondToAppraisalRequestFromJSON,
    RespondToAppraisalRequestToJSON,
    ShareClaimRequestFromJSON,
    ShareClaimRequestToJSON,
    ShareClaimResponseFromJSON,
    ShareClaimResponseToJSON,
    UpdateClaimAccess200ResponseFromJSON,
    UpdateClaimAccess200ResponseToJSON,
    UpdateClaimAccessRequestFromJSON,
    UpdateClaimAccessRequestToJSON,
    UpdateClaimRequestFromJSON,
    UpdateClaimRequestToJSON,
    WidgetPublicConfigFromJSON,
    WidgetPublicConfigToJSON,
    WidgetSubmitRequestFromJSON,
    WidgetSubmitRequestToJSON,
    WidgetSubmitResponseFromJSON,
    WidgetSubmitResponseToJSON,
} from '../models/index';

export interface CreateClaimOperationRequest {
    createClaimRequest: CreateClaimRequest;
}

export interface CreateClaimWidgetOperationRequest {
    createClaimWidgetRequest: CreateClaimWidgetRequest;
}

export interface DeleteClaimRequest {
    claimId: number;
}

export interface DeleteClaimWidgetRequest {
    widgetId: number;
}

export interface GetAssignableUsersRequest {
    claimId: number;
}

export interface GetClaimRequest {
    claimId: number;
}

export interface GetClaimContactsRequest {
    claimId: number;
    limit?: number;
    offset?: number;
}

export interface GetClaimLinkedContactRequest {
    claimId: number;
    contactId: number;
}

export interface GetClaimLinkedOrganizationRequest {
    claimId: number;
    organizationId: number;
}

export interface GetClaimLinkedPropertyRequest {
    claimId: number;
    propertyId: number;
}

export interface GetClaimOrganizationsRequest {
    claimId: number;
    limit?: number;
    offset?: number;
}

export interface GetClaimPropertiesRequest {
    claimId: number;
    limit?: number;
    offset?: number;
}

export interface GetClaimSharesRequest {
    claimId: number;
}

export interface GetPublicClaimWidgetConfigRequest {
    publicKey: string;
}

export interface GetSharedClaimFilterOptionsRequest {
    archivedOnly?: boolean;
}

export interface GetStatusTemplatesForClaimRequest {
    claimId: number;
}

export interface LinkClaimContactOperationRequest {
    claimId: number;
    linkClaimContactRequest: LinkClaimContactRequest;
}

export interface LinkClaimOrganizationOperationRequest {
    claimId: number;
    linkClaimOrganizationRequest: LinkClaimOrganizationRequest;
}

export interface LinkClaimPropertyOperationRequest {
    claimId: number;
    linkClaimPropertyRequest: LinkClaimPropertyRequest;
}

export interface ListClaimsRequest {
    page?: number;
    limit?: number;
    search?: string;
    claimStatusTemplateId?: number;
    pipelineId?: number;
    claimFolderId?: number;
    assigneeUserId?: number;
    includeArchived?: boolean;
    archivedOnly?: boolean;
}

export interface RespondToAppraisalOperationRequest {
    claimId: number;
    respondToAppraisalRequest: RespondToAppraisalRequest;
}

export interface RevokeClaimAccessRequest {
    claimId: number;
    shareId: number;
}

export interface RevokeClaimInviteRequest {
    claimId: number;
    inviteId: number;
}

export interface ShareClaimOperationRequest {
    claimId: number;
    shareClaimRequest: ShareClaimRequest;
}

export interface SubmitPublicClaimWidgetRequest {
    publicKey: string;
    widgetSubmitRequest: WidgetSubmitRequest;
}

export interface UnlinkClaimContactRequest {
    claimId: number;
    contactId: number;
}

export interface UnlinkClaimOrganizationRequest {
    claimId: number;
    organizationId: number;
}

export interface UnlinkClaimPropertyRequest {
    claimId: number;
    propertyId: number;
    addressType?: UnlinkClaimPropertyAddressTypeEnum;
}

export interface UpdateClaimOperationRequest {
    claimId: number;
    updateClaimRequest: UpdateClaimRequest;
}

export interface UpdateClaimAccessOperationRequest {
    claimId: number;
    shareId: number;
    updateClaimAccessRequest: UpdateClaimAccessRequest;
}

/**
 * ClaimsApi - interface
 * 
 * @export
 * @interface ClaimsApiInterface
 */
export interface ClaimsApiInterface {
    /**
     * 
     * @summary Create a claim
     * @param {CreateClaimRequest} createClaimRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimsApiInterface
     */
    createClaimRaw(requestParameters: CreateClaimOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimDetailed>>;

    /**
     * Create a claim
     */
    createClaim(requestParameters: CreateClaimOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimDetailed>;

    /**
     * 
     * @summary Create claim widget
     * @param {CreateClaimWidgetRequest} createClaimWidgetRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimsApiInterface
     */
    createClaimWidgetRaw(requestParameters: CreateClaimWidgetOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimWidget>>;

    /**
     * Create claim widget
     */
    createClaimWidget(requestParameters: CreateClaimWidgetOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimWidget>;

    /**
     * 
     * @summary Delete a claim by id
     * @param {number} claimId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimsApiInterface
     */
    deleteClaimRaw(requestParameters: DeleteClaimRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Delete a claim by id
     */
    deleteClaim(requestParameters: DeleteClaimRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Delete claim widget
     * @param {number} widgetId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimsApiInterface
     */
    deleteClaimWidgetRaw(requestParameters: DeleteClaimWidgetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Delete claim widget
     */
    deleteClaimWidget(requestParameters: DeleteClaimWidgetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Returns company members who do not already have explicit user-level claim_access for this claim. Any user with access to the claim can call this endpoint to see which company members they can grant access to.
     * @summary Get users that can be assigned to a claim
     * @param {number} claimId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimsApiInterface
     */
    getAssignableUsersRaw(requestParameters: GetAssignableUsersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetAssignableUsers200Response>>;

    /**
     * Returns company members who do not already have explicit user-level claim_access for this claim. Any user with access to the claim can call this endpoint to see which company members they can grant access to.
     * Get users that can be assigned to a claim
     */
    getAssignableUsers(requestParameters: GetAssignableUsersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetAssignableUsers200Response>;

    /**
     * 
     * @summary Get a claim by id (detailed)
     * @param {number} claimId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimsApiInterface
     */
    getClaimRaw(requestParameters: GetClaimRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimDetailed>>;

    /**
     * Get a claim by id (detailed)
     */
    getClaim(requestParameters: GetClaimRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimDetailed>;

    /**
     * Returns the distinct users (including the caller) who hold a user-level claim access grant on any claim the caller can access. Used to populate the assignee filter on the claims list.
     * @summary Get distinct users assigned across the caller\'s accessible claims
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimsApiInterface
     */
    getClaimAssigneesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetClaimAssignees200Response>>;

    /**
     * Returns the distinct users (including the caller) who hold a user-level claim access grant on any claim the caller can access. Used to populate the assignee filter on the claims list.
     * Get distinct users assigned across the caller\'s accessible claims
     */
    getClaimAssignees(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetClaimAssignees200Response>;

    /**
     * 
     * @summary List contacts linked to a claim
     * @param {number} claimId 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimsApiInterface
     */
    getClaimContactsRaw(requestParameters: GetClaimContactsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimContactsResponse>>;

    /**
     * List contacts linked to a claim
     */
    getClaimContacts(requestParameters: GetClaimContactsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimContactsResponse>;

    /**
     * 
     * @summary Get a contact linked to an accessible claim
     * @param {number} claimId 
     * @param {number} contactId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimsApiInterface
     */
    getClaimLinkedContactRaw(requestParameters: GetClaimLinkedContactRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Contact>>;

    /**
     * Get a contact linked to an accessible claim
     */
    getClaimLinkedContact(requestParameters: GetClaimLinkedContactRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Contact>;

    /**
     * 
     * @summary Get an organization linked to an accessible claim
     * @param {number} claimId 
     * @param {number} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimsApiInterface
     */
    getClaimLinkedOrganizationRaw(requestParameters: GetClaimLinkedOrganizationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Organization>>;

    /**
     * Get an organization linked to an accessible claim
     */
    getClaimLinkedOrganization(requestParameters: GetClaimLinkedOrganizationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Organization>;

    /**
     * 
     * @summary Get a property linked to an accessible claim
     * @param {number} claimId 
     * @param {number} propertyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimsApiInterface
     */
    getClaimLinkedPropertyRaw(requestParameters: GetClaimLinkedPropertyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Property>>;

    /**
     * Get a property linked to an accessible claim
     */
    getClaimLinkedProperty(requestParameters: GetClaimLinkedPropertyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Property>;

    /**
     * 
     * @summary List organizations linked to a claim
     * @param {number} claimId 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimsApiInterface
     */
    getClaimOrganizationsRaw(requestParameters: GetClaimOrganizationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimOrganizationsResponse>>;

    /**
     * List organizations linked to a claim
     */
    getClaimOrganizations(requestParameters: GetClaimOrganizationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimOrganizationsResponse>;

    /**
     * 
     * @summary List properties linked to a claim
     * @param {number} claimId 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimsApiInterface
     */
    getClaimPropertiesRaw(requestParameters: GetClaimPropertiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimPropertiesResponse>>;

    /**
     * List properties linked to a claim
     */
    getClaimProperties(requestParameters: GetClaimPropertiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimPropertiesResponse>;

    /**
     * 
     * @summary Get all shares for a claim
     * @param {number} claimId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimsApiInterface
     */
    getClaimSharesRaw(requestParameters: GetClaimSharesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetClaimShares200Response>>;

    /**
     * Get all shares for a claim
     */
    getClaimShares(requestParameters: GetClaimSharesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetClaimShares200Response>;

    /**
     * 
     * @summary Aggregate claim stats for dashboards
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimsApiInterface
     */
    getClaimStatsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimStats>>;

    /**
     * Aggregate claim stats for dashboards
     */
    getClaimStats(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimStats>;

    /**
     * 
     * @summary Get public widget config
     * @param {string} publicKey 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimsApiInterface
     */
    getPublicClaimWidgetConfigRaw(requestParameters: GetPublicClaimWidgetConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WidgetPublicConfig>>;

    /**
     * Get public widget config
     */
    getPublicClaimWidgetConfig(requestParameters: GetPublicClaimWidgetConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WidgetPublicConfig>;

    /**
     * Returns workflows and statuses currently used by claims owned by another company that the caller can access. Does not expose unused status templates. The archivedOnly parameter scopes both workflows and statuses. Independent of pagination and other claim filters.
     * @summary Get workflow and current status options from accessible shared claims
     * @param {boolean} [archivedOnly] Return workflows used by archived claims instead of active claims.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimsApiInterface
     */
    getSharedClaimFilterOptionsRaw(requestParameters: GetSharedClaimFilterOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetSharedClaimFilterOptions200Response>>;

    /**
     * Returns workflows and statuses currently used by claims owned by another company that the caller can access. Does not expose unused status templates. The archivedOnly parameter scopes both workflows and statuses. Independent of pagination and other claim filters.
     * Get workflow and current status options from accessible shared claims
     */
    getSharedClaimFilterOptions(requestParameters: GetSharedClaimFilterOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetSharedClaimFilterOptions200Response>;

    /**
     * Returns the active status templates belonging to the company that owns this claim. Available to any user with claim access, including cross-company collaborators, so they can resolve the claim\'s status label even when it belongs to another company.
     * @summary Get status templates for a claim\'s owning company
     * @param {number} claimId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimsApiInterface
     */
    getStatusTemplatesForClaimRaw(requestParameters: GetStatusTemplatesForClaimRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimStatusTemplateListResponse>>;

    /**
     * Returns the active status templates belonging to the company that owns this claim. Available to any user with claim access, including cross-company collaborators, so they can resolve the claim\'s status label even when it belongs to another company.
     * Get status templates for a claim\'s owning company
     */
    getStatusTemplatesForClaim(requestParameters: GetStatusTemplatesForClaimRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimStatusTemplateListResponse>;

    /**
     * 
     * @summary Link a contact to a claim
     * @param {number} claimId 
     * @param {LinkClaimContactRequest} linkClaimContactRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimsApiInterface
     */
    linkClaimContactRaw(requestParameters: LinkClaimContactOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimContact>>;

    /**
     * Link a contact to a claim
     */
    linkClaimContact(requestParameters: LinkClaimContactOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimContact>;

    /**
     * 
     * @summary Link an organization to a claim
     * @param {number} claimId 
     * @param {LinkClaimOrganizationRequest} linkClaimOrganizationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimsApiInterface
     */
    linkClaimOrganizationRaw(requestParameters: LinkClaimOrganizationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimOrganization>>;

    /**
     * Link an organization to a claim
     */
    linkClaimOrganization(requestParameters: LinkClaimOrganizationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimOrganization>;

    /**
     * 
     * @summary Link a property to a claim
     * @param {number} claimId 
     * @param {LinkClaimPropertyRequest} linkClaimPropertyRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimsApiInterface
     */
    linkClaimPropertyRaw(requestParameters: LinkClaimPropertyOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimProperty>>;

    /**
     * Link a property to a claim
     */
    linkClaimProperty(requestParameters: LinkClaimPropertyOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimProperty>;

    /**
     * 
     * @summary List claim widgets for the current company
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimsApiInterface
     */
    listClaimWidgetsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListClaimWidgets200Response>>;

    /**
     * List claim widgets for the current company
     */
    listClaimWidgets(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListClaimWidgets200Response>;

    /**
     * 
     * @summary List claims
     * @param {number} [page] 
     * @param {number} [limit] 
     * @param {string} [search] Search by claim number, insured name, or policy number
     * @param {number} [claimStatusTemplateId] Filter by claim status template ID
     * @param {number} [pipelineId] Filter by pipeline ID
     * @param {number} [claimFolderId] Filter by claim folder ID
     * @param {number} [assigneeUserId] Filter by assigned user ID (user-level claim access)
     * @param {boolean} [includeArchived] Include archived claims in results.
     * @param {boolean} [archivedOnly] Return only archived claims.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimsApiInterface
     */
    listClaimsRaw(requestParameters: ListClaimsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimListResponse>>;

    /**
     * List claims
     */
    listClaims(requestParameters: ListClaimsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimListResponse>;

    /**
     * 
     * @summary Appraiser marks an outcome on an appraisal request
     * @param {number} claimId 
     * @param {RespondToAppraisalRequest} respondToAppraisalRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimsApiInterface
     */
    respondToAppraisalRaw(requestParameters: RespondToAppraisalOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RespondToAppraisal201Response>>;

    /**
     * Appraiser marks an outcome on an appraisal request
     */
    respondToAppraisal(requestParameters: RespondToAppraisalOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RespondToAppraisal201Response>;

    /**
     * 
     * @summary Revoke a claim share
     * @param {number} claimId 
     * @param {number} shareId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimsApiInterface
     */
    revokeClaimAccessRaw(requestParameters: RevokeClaimAccessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Revoke a claim share
     */
    revokeClaimAccess(requestParameters: RevokeClaimAccessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Revokes a pending email invite for someone who has not yet created an account.
     * @summary Revoke a pending email invite
     * @param {number} claimId 
     * @param {number} inviteId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimsApiInterface
     */
    revokeClaimInviteRaw(requestParameters: RevokeClaimInviteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Revokes a pending email invite for someone who has not yet created an account.
     * Revoke a pending email invite
     */
    revokeClaimInvite(requestParameters: RevokeClaimInviteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Share a claim with a user, company, or by email
     * @param {number} claimId 
     * @param {ShareClaimRequest} shareClaimRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimsApiInterface
     */
    shareClaimRaw(requestParameters: ShareClaimOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ShareClaimResponse>>;

    /**
     * Share a claim with a user, company, or by email
     */
    shareClaim(requestParameters: ShareClaimOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ShareClaimResponse>;

    /**
     * 
     * @summary Submit public widget claim
     * @param {string} publicKey 
     * @param {WidgetSubmitRequest} widgetSubmitRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimsApiInterface
     */
    submitPublicClaimWidgetRaw(requestParameters: SubmitPublicClaimWidgetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WidgetSubmitResponse>>;

    /**
     * Submit public widget claim
     */
    submitPublicClaimWidget(requestParameters: SubmitPublicClaimWidgetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WidgetSubmitResponse>;

    /**
     * 
     * @summary Unlink a contact from a claim
     * @param {number} claimId 
     * @param {number} contactId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimsApiInterface
     */
    unlinkClaimContactRaw(requestParameters: UnlinkClaimContactRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Unlink a contact from a claim
     */
    unlinkClaimContact(requestParameters: UnlinkClaimContactRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Unlink an organization from a claim
     * @param {number} claimId 
     * @param {number} organizationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimsApiInterface
     */
    unlinkClaimOrganizationRaw(requestParameters: UnlinkClaimOrganizationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Unlink an organization from a claim
     */
    unlinkClaimOrganization(requestParameters: UnlinkClaimOrganizationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * When addressType is provided, only the specific link with that address type is removed. When omitted, all links between the claim and property are removed. 
     * @summary Unlink a property from a claim
     * @param {number} claimId 
     * @param {number} propertyId 
     * @param {string} [addressType] When provided, only removes the link with the specified address type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimsApiInterface
     */
    unlinkClaimPropertyRaw(requestParameters: UnlinkClaimPropertyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * When addressType is provided, only the specific link with that address type is removed. When omitted, all links between the claim and property are removed. 
     * Unlink a property from a claim
     */
    unlinkClaimProperty(requestParameters: UnlinkClaimPropertyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Update a claim by id
     * @param {number} claimId 
     * @param {UpdateClaimRequest} updateClaimRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimsApiInterface
     */
    updateClaimRaw(requestParameters: UpdateClaimOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimDetailed>>;

    /**
     * Update a claim by id
     */
    updateClaim(requestParameters: UpdateClaimOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimDetailed>;

    /**
     * 
     * @summary Update a claim share\'s permissions
     * @param {number} claimId 
     * @param {number} shareId 
     * @param {UpdateClaimAccessRequest} updateClaimAccessRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimsApiInterface
     */
    updateClaimAccessRaw(requestParameters: UpdateClaimAccessOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateClaimAccess200Response>>;

    /**
     * Update a claim share\'s permissions
     */
    updateClaimAccess(requestParameters: UpdateClaimAccessOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdateClaimAccess200Response>;

}

/**
 * 
 */
export class ClaimsApi extends runtime.BaseAPI implements ClaimsApiInterface {

    /**
     * Create a claim
     */
    async createClaimRaw(requestParameters: CreateClaimOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimDetailed>> {
        if (requestParameters['createClaimRequest'] == null) {
            throw new runtime.RequiredError(
                'createClaimRequest',
                'Required parameter "createClaimRequest" was null or undefined when calling createClaim().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/claims`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateClaimRequestToJSON(requestParameters['createClaimRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimDetailedFromJSON(jsonValue));
    }

    /**
     * Create a claim
     */
    async createClaim(requestParameters: CreateClaimOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimDetailed> {
        const response = await this.createClaimRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create claim widget
     */
    async createClaimWidgetRaw(requestParameters: CreateClaimWidgetOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimWidget>> {
        if (requestParameters['createClaimWidgetRequest'] == null) {
            throw new runtime.RequiredError(
                'createClaimWidgetRequest',
                'Required parameter "createClaimWidgetRequest" was null or undefined when calling createClaimWidget().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/claim-widgets`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateClaimWidgetRequestToJSON(requestParameters['createClaimWidgetRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimWidgetFromJSON(jsonValue));
    }

    /**
     * Create claim widget
     */
    async createClaimWidget(requestParameters: CreateClaimWidgetOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimWidget> {
        const response = await this.createClaimWidgetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a claim by id
     */
    async deleteClaimRaw(requestParameters: DeleteClaimRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['claimId'] == null) {
            throw new runtime.RequiredError(
                'claimId',
                'Required parameter "claimId" was null or undefined when calling deleteClaim().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/claims/{claimId}`.replace(`{${"claimId"}}`, encodeURIComponent(String(requestParameters['claimId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a claim by id
     */
    async deleteClaim(requestParameters: DeleteClaimRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteClaimRaw(requestParameters, initOverrides);
    }

    /**
     * Delete claim widget
     */
    async deleteClaimWidgetRaw(requestParameters: DeleteClaimWidgetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['widgetId'] == null) {
            throw new runtime.RequiredError(
                'widgetId',
                'Required parameter "widgetId" was null or undefined when calling deleteClaimWidget().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/claim-widgets/{widgetId}`.replace(`{${"widgetId"}}`, encodeURIComponent(String(requestParameters['widgetId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete claim widget
     */
    async deleteClaimWidget(requestParameters: DeleteClaimWidgetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteClaimWidgetRaw(requestParameters, initOverrides);
    }

    /**
     * Returns company members who do not already have explicit user-level claim_access for this claim. Any user with access to the claim can call this endpoint to see which company members they can grant access to.
     * Get users that can be assigned to a claim
     */
    async getAssignableUsersRaw(requestParameters: GetAssignableUsersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetAssignableUsers200Response>> {
        if (requestParameters['claimId'] == null) {
            throw new runtime.RequiredError(
                'claimId',
                'Required parameter "claimId" was null or undefined when calling getAssignableUsers().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/claims/{claimId}/assignable-users`.replace(`{${"claimId"}}`, encodeURIComponent(String(requestParameters['claimId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetAssignableUsers200ResponseFromJSON(jsonValue));
    }

    /**
     * Returns company members who do not already have explicit user-level claim_access for this claim. Any user with access to the claim can call this endpoint to see which company members they can grant access to.
     * Get users that can be assigned to a claim
     */
    async getAssignableUsers(requestParameters: GetAssignableUsersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetAssignableUsers200Response> {
        const response = await this.getAssignableUsersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a claim by id (detailed)
     */
    async getClaimRaw(requestParameters: GetClaimRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimDetailed>> {
        if (requestParameters['claimId'] == null) {
            throw new runtime.RequiredError(
                'claimId',
                'Required parameter "claimId" was null or undefined when calling getClaim().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/claims/{claimId}`.replace(`{${"claimId"}}`, encodeURIComponent(String(requestParameters['claimId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimDetailedFromJSON(jsonValue));
    }

    /**
     * Get a claim by id (detailed)
     */
    async getClaim(requestParameters: GetClaimRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimDetailed> {
        const response = await this.getClaimRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns the distinct users (including the caller) who hold a user-level claim access grant on any claim the caller can access. Used to populate the assignee filter on the claims list.
     * Get distinct users assigned across the caller\'s accessible claims
     */
    async getClaimAssigneesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetClaimAssignees200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/claims/assignees`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetClaimAssignees200ResponseFromJSON(jsonValue));
    }

    /**
     * Returns the distinct users (including the caller) who hold a user-level claim access grant on any claim the caller can access. Used to populate the assignee filter on the claims list.
     * Get distinct users assigned across the caller\'s accessible claims
     */
    async getClaimAssignees(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetClaimAssignees200Response> {
        const response = await this.getClaimAssigneesRaw(initOverrides);
        return await response.value();
    }

    /**
     * List contacts linked to a claim
     */
    async getClaimContactsRaw(requestParameters: GetClaimContactsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimContactsResponse>> {
        if (requestParameters['claimId'] == null) {
            throw new runtime.RequiredError(
                'claimId',
                'Required parameter "claimId" was null or undefined when calling getClaimContacts().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/claims/{claimId}/contacts`.replace(`{${"claimId"}}`, encodeURIComponent(String(requestParameters['claimId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimContactsResponseFromJSON(jsonValue));
    }

    /**
     * List contacts linked to a claim
     */
    async getClaimContacts(requestParameters: GetClaimContactsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimContactsResponse> {
        const response = await this.getClaimContactsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a contact linked to an accessible claim
     */
    async getClaimLinkedContactRaw(requestParameters: GetClaimLinkedContactRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Contact>> {
        if (requestParameters['claimId'] == null) {
            throw new runtime.RequiredError(
                'claimId',
                'Required parameter "claimId" was null or undefined when calling getClaimLinkedContact().'
            );
        }

        if (requestParameters['contactId'] == null) {
            throw new runtime.RequiredError(
                'contactId',
                'Required parameter "contactId" was null or undefined when calling getClaimLinkedContact().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/claims/{claimId}/contacts/{contactId}`.replace(`{${"claimId"}}`, encodeURIComponent(String(requestParameters['claimId']))).replace(`{${"contactId"}}`, encodeURIComponent(String(requestParameters['contactId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ContactFromJSON(jsonValue));
    }

    /**
     * Get a contact linked to an accessible claim
     */
    async getClaimLinkedContact(requestParameters: GetClaimLinkedContactRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Contact> {
        const response = await this.getClaimLinkedContactRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get an organization linked to an accessible claim
     */
    async getClaimLinkedOrganizationRaw(requestParameters: GetClaimLinkedOrganizationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Organization>> {
        if (requestParameters['claimId'] == null) {
            throw new runtime.RequiredError(
                'claimId',
                'Required parameter "claimId" was null or undefined when calling getClaimLinkedOrganization().'
            );
        }

        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling getClaimLinkedOrganization().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/claims/{claimId}/organizations/{organizationId}`.replace(`{${"claimId"}}`, encodeURIComponent(String(requestParameters['claimId']))).replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrganizationFromJSON(jsonValue));
    }

    /**
     * Get an organization linked to an accessible claim
     */
    async getClaimLinkedOrganization(requestParameters: GetClaimLinkedOrganizationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Organization> {
        const response = await this.getClaimLinkedOrganizationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a property linked to an accessible claim
     */
    async getClaimLinkedPropertyRaw(requestParameters: GetClaimLinkedPropertyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Property>> {
        if (requestParameters['claimId'] == null) {
            throw new runtime.RequiredError(
                'claimId',
                'Required parameter "claimId" was null or undefined when calling getClaimLinkedProperty().'
            );
        }

        if (requestParameters['propertyId'] == null) {
            throw new runtime.RequiredError(
                'propertyId',
                'Required parameter "propertyId" was null or undefined when calling getClaimLinkedProperty().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/claims/{claimId}/properties/{propertyId}`.replace(`{${"claimId"}}`, encodeURIComponent(String(requestParameters['claimId']))).replace(`{${"propertyId"}}`, encodeURIComponent(String(requestParameters['propertyId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PropertyFromJSON(jsonValue));
    }

    /**
     * Get a property linked to an accessible claim
     */
    async getClaimLinkedProperty(requestParameters: GetClaimLinkedPropertyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Property> {
        const response = await this.getClaimLinkedPropertyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List organizations linked to a claim
     */
    async getClaimOrganizationsRaw(requestParameters: GetClaimOrganizationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimOrganizationsResponse>> {
        if (requestParameters['claimId'] == null) {
            throw new runtime.RequiredError(
                'claimId',
                'Required parameter "claimId" was null or undefined when calling getClaimOrganizations().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/claims/{claimId}/organizations`.replace(`{${"claimId"}}`, encodeURIComponent(String(requestParameters['claimId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimOrganizationsResponseFromJSON(jsonValue));
    }

    /**
     * List organizations linked to a claim
     */
    async getClaimOrganizations(requestParameters: GetClaimOrganizationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimOrganizationsResponse> {
        const response = await this.getClaimOrganizationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List properties linked to a claim
     */
    async getClaimPropertiesRaw(requestParameters: GetClaimPropertiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimPropertiesResponse>> {
        if (requestParameters['claimId'] == null) {
            throw new runtime.RequiredError(
                'claimId',
                'Required parameter "claimId" was null or undefined when calling getClaimProperties().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/claims/{claimId}/properties`.replace(`{${"claimId"}}`, encodeURIComponent(String(requestParameters['claimId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimPropertiesResponseFromJSON(jsonValue));
    }

    /**
     * List properties linked to a claim
     */
    async getClaimProperties(requestParameters: GetClaimPropertiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimPropertiesResponse> {
        const response = await this.getClaimPropertiesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all shares for a claim
     */
    async getClaimSharesRaw(requestParameters: GetClaimSharesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetClaimShares200Response>> {
        if (requestParameters['claimId'] == null) {
            throw new runtime.RequiredError(
                'claimId',
                'Required parameter "claimId" was null or undefined when calling getClaimShares().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/claims/{claimId}/shares`.replace(`{${"claimId"}}`, encodeURIComponent(String(requestParameters['claimId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetClaimShares200ResponseFromJSON(jsonValue));
    }

    /**
     * Get all shares for a claim
     */
    async getClaimShares(requestParameters: GetClaimSharesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetClaimShares200Response> {
        const response = await this.getClaimSharesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Aggregate claim stats for dashboards
     */
    async getClaimStatsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimStats>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/claims/stats`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimStatsFromJSON(jsonValue));
    }

    /**
     * Aggregate claim stats for dashboards
     */
    async getClaimStats(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimStats> {
        const response = await this.getClaimStatsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get public widget config
     */
    async getPublicClaimWidgetConfigRaw(requestParameters: GetPublicClaimWidgetConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WidgetPublicConfig>> {
        if (requestParameters['publicKey'] == null) {
            throw new runtime.RequiredError(
                'publicKey',
                'Required parameter "publicKey" was null or undefined when calling getPublicClaimWidgetConfig().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/public/widget/{publicKey}/config`.replace(`{${"publicKey"}}`, encodeURIComponent(String(requestParameters['publicKey']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WidgetPublicConfigFromJSON(jsonValue));
    }

    /**
     * Get public widget config
     */
    async getPublicClaimWidgetConfig(requestParameters: GetPublicClaimWidgetConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WidgetPublicConfig> {
        const response = await this.getPublicClaimWidgetConfigRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns workflows and statuses currently used by claims owned by another company that the caller can access. Does not expose unused status templates. The archivedOnly parameter scopes both workflows and statuses. Independent of pagination and other claim filters.
     * Get workflow and current status options from accessible shared claims
     */
    async getSharedClaimFilterOptionsRaw(requestParameters: GetSharedClaimFilterOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetSharedClaimFilterOptions200Response>> {
        const queryParameters: any = {};

        if (requestParameters['archivedOnly'] != null) {
            queryParameters['archivedOnly'] = requestParameters['archivedOnly'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/claims/shared-filter-options`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetSharedClaimFilterOptions200ResponseFromJSON(jsonValue));
    }

    /**
     * Returns workflows and statuses currently used by claims owned by another company that the caller can access. Does not expose unused status templates. The archivedOnly parameter scopes both workflows and statuses. Independent of pagination and other claim filters.
     * Get workflow and current status options from accessible shared claims
     */
    async getSharedClaimFilterOptions(requestParameters: GetSharedClaimFilterOptionsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetSharedClaimFilterOptions200Response> {
        const response = await this.getSharedClaimFilterOptionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns the active status templates belonging to the company that owns this claim. Available to any user with claim access, including cross-company collaborators, so they can resolve the claim\'s status label even when it belongs to another company.
     * Get status templates for a claim\'s owning company
     */
    async getStatusTemplatesForClaimRaw(requestParameters: GetStatusTemplatesForClaimRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimStatusTemplateListResponse>> {
        if (requestParameters['claimId'] == null) {
            throw new runtime.RequiredError(
                'claimId',
                'Required parameter "claimId" was null or undefined when calling getStatusTemplatesForClaim().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/claims/{claimId}/status-templates`.replace(`{${"claimId"}}`, encodeURIComponent(String(requestParameters['claimId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimStatusTemplateListResponseFromJSON(jsonValue));
    }

    /**
     * Returns the active status templates belonging to the company that owns this claim. Available to any user with claim access, including cross-company collaborators, so they can resolve the claim\'s status label even when it belongs to another company.
     * Get status templates for a claim\'s owning company
     */
    async getStatusTemplatesForClaim(requestParameters: GetStatusTemplatesForClaimRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimStatusTemplateListResponse> {
        const response = await this.getStatusTemplatesForClaimRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Link a contact to a claim
     */
    async linkClaimContactRaw(requestParameters: LinkClaimContactOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimContact>> {
        if (requestParameters['claimId'] == null) {
            throw new runtime.RequiredError(
                'claimId',
                'Required parameter "claimId" was null or undefined when calling linkClaimContact().'
            );
        }

        if (requestParameters['linkClaimContactRequest'] == null) {
            throw new runtime.RequiredError(
                'linkClaimContactRequest',
                'Required parameter "linkClaimContactRequest" was null or undefined when calling linkClaimContact().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/claims/{claimId}/contacts`.replace(`{${"claimId"}}`, encodeURIComponent(String(requestParameters['claimId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: LinkClaimContactRequestToJSON(requestParameters['linkClaimContactRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimContactFromJSON(jsonValue));
    }

    /**
     * Link a contact to a claim
     */
    async linkClaimContact(requestParameters: LinkClaimContactOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimContact> {
        const response = await this.linkClaimContactRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Link an organization to a claim
     */
    async linkClaimOrganizationRaw(requestParameters: LinkClaimOrganizationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimOrganization>> {
        if (requestParameters['claimId'] == null) {
            throw new runtime.RequiredError(
                'claimId',
                'Required parameter "claimId" was null or undefined when calling linkClaimOrganization().'
            );
        }

        if (requestParameters['linkClaimOrganizationRequest'] == null) {
            throw new runtime.RequiredError(
                'linkClaimOrganizationRequest',
                'Required parameter "linkClaimOrganizationRequest" was null or undefined when calling linkClaimOrganization().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/claims/{claimId}/organizations`.replace(`{${"claimId"}}`, encodeURIComponent(String(requestParameters['claimId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: LinkClaimOrganizationRequestToJSON(requestParameters['linkClaimOrganizationRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimOrganizationFromJSON(jsonValue));
    }

    /**
     * Link an organization to a claim
     */
    async linkClaimOrganization(requestParameters: LinkClaimOrganizationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimOrganization> {
        const response = await this.linkClaimOrganizationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Link a property to a claim
     */
    async linkClaimPropertyRaw(requestParameters: LinkClaimPropertyOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimProperty>> {
        if (requestParameters['claimId'] == null) {
            throw new runtime.RequiredError(
                'claimId',
                'Required parameter "claimId" was null or undefined when calling linkClaimProperty().'
            );
        }

        if (requestParameters['linkClaimPropertyRequest'] == null) {
            throw new runtime.RequiredError(
                'linkClaimPropertyRequest',
                'Required parameter "linkClaimPropertyRequest" was null or undefined when calling linkClaimProperty().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/claims/{claimId}/properties`.replace(`{${"claimId"}}`, encodeURIComponent(String(requestParameters['claimId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: LinkClaimPropertyRequestToJSON(requestParameters['linkClaimPropertyRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimPropertyFromJSON(jsonValue));
    }

    /**
     * Link a property to a claim
     */
    async linkClaimProperty(requestParameters: LinkClaimPropertyOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimProperty> {
        const response = await this.linkClaimPropertyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List claim widgets for the current company
     */
    async listClaimWidgetsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListClaimWidgets200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/claim-widgets`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListClaimWidgets200ResponseFromJSON(jsonValue));
    }

    /**
     * List claim widgets for the current company
     */
    async listClaimWidgets(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListClaimWidgets200Response> {
        const response = await this.listClaimWidgetsRaw(initOverrides);
        return await response.value();
    }

    /**
     * List claims
     */
    async listClaimsRaw(requestParameters: ListClaimsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimListResponse>> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['claimStatusTemplateId'] != null) {
            queryParameters['claimStatusTemplateId'] = requestParameters['claimStatusTemplateId'];
        }

        if (requestParameters['pipelineId'] != null) {
            queryParameters['pipelineId'] = requestParameters['pipelineId'];
        }

        if (requestParameters['claimFolderId'] != null) {
            queryParameters['claimFolderId'] = requestParameters['claimFolderId'];
        }

        if (requestParameters['assigneeUserId'] != null) {
            queryParameters['assigneeUserId'] = requestParameters['assigneeUserId'];
        }

        if (requestParameters['includeArchived'] != null) {
            queryParameters['includeArchived'] = requestParameters['includeArchived'];
        }

        if (requestParameters['archivedOnly'] != null) {
            queryParameters['archivedOnly'] = requestParameters['archivedOnly'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/claims`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimListResponseFromJSON(jsonValue));
    }

    /**
     * List claims
     */
    async listClaims(requestParameters: ListClaimsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimListResponse> {
        const response = await this.listClaimsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Appraiser marks an outcome on an appraisal request
     */
    async respondToAppraisalRaw(requestParameters: RespondToAppraisalOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RespondToAppraisal201Response>> {
        if (requestParameters['claimId'] == null) {
            throw new runtime.RequiredError(
                'claimId',
                'Required parameter "claimId" was null or undefined when calling respondToAppraisal().'
            );
        }

        if (requestParameters['respondToAppraisalRequest'] == null) {
            throw new runtime.RequiredError(
                'respondToAppraisalRequest',
                'Required parameter "respondToAppraisalRequest" was null or undefined when calling respondToAppraisal().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/claims/{claimId}/appraisal-response`.replace(`{${"claimId"}}`, encodeURIComponent(String(requestParameters['claimId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RespondToAppraisalRequestToJSON(requestParameters['respondToAppraisalRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RespondToAppraisal201ResponseFromJSON(jsonValue));
    }

    /**
     * Appraiser marks an outcome on an appraisal request
     */
    async respondToAppraisal(requestParameters: RespondToAppraisalOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RespondToAppraisal201Response> {
        const response = await this.respondToAppraisalRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Revoke a claim share
     */
    async revokeClaimAccessRaw(requestParameters: RevokeClaimAccessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['claimId'] == null) {
            throw new runtime.RequiredError(
                'claimId',
                'Required parameter "claimId" was null or undefined when calling revokeClaimAccess().'
            );
        }

        if (requestParameters['shareId'] == null) {
            throw new runtime.RequiredError(
                'shareId',
                'Required parameter "shareId" was null or undefined when calling revokeClaimAccess().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/claims/{claimId}/shares/{shareId}`.replace(`{${"claimId"}}`, encodeURIComponent(String(requestParameters['claimId']))).replace(`{${"shareId"}}`, encodeURIComponent(String(requestParameters['shareId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Revoke a claim share
     */
    async revokeClaimAccess(requestParameters: RevokeClaimAccessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.revokeClaimAccessRaw(requestParameters, initOverrides);
    }

    /**
     * Revokes a pending email invite for someone who has not yet created an account.
     * Revoke a pending email invite
     */
    async revokeClaimInviteRaw(requestParameters: RevokeClaimInviteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['claimId'] == null) {
            throw new runtime.RequiredError(
                'claimId',
                'Required parameter "claimId" was null or undefined when calling revokeClaimInvite().'
            );
        }

        if (requestParameters['inviteId'] == null) {
            throw new runtime.RequiredError(
                'inviteId',
                'Required parameter "inviteId" was null or undefined when calling revokeClaimInvite().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/claims/{claimId}/invites/{inviteId}`.replace(`{${"claimId"}}`, encodeURIComponent(String(requestParameters['claimId']))).replace(`{${"inviteId"}}`, encodeURIComponent(String(requestParameters['inviteId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Revokes a pending email invite for someone who has not yet created an account.
     * Revoke a pending email invite
     */
    async revokeClaimInvite(requestParameters: RevokeClaimInviteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.revokeClaimInviteRaw(requestParameters, initOverrides);
    }

    /**
     * Share a claim with a user, company, or by email
     */
    async shareClaimRaw(requestParameters: ShareClaimOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ShareClaimResponse>> {
        if (requestParameters['claimId'] == null) {
            throw new runtime.RequiredError(
                'claimId',
                'Required parameter "claimId" was null or undefined when calling shareClaim().'
            );
        }

        if (requestParameters['shareClaimRequest'] == null) {
            throw new runtime.RequiredError(
                'shareClaimRequest',
                'Required parameter "shareClaimRequest" was null or undefined when calling shareClaim().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/claims/{claimId}/shares`.replace(`{${"claimId"}}`, encodeURIComponent(String(requestParameters['claimId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ShareClaimRequestToJSON(requestParameters['shareClaimRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShareClaimResponseFromJSON(jsonValue));
    }

    /**
     * Share a claim with a user, company, or by email
     */
    async shareClaim(requestParameters: ShareClaimOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ShareClaimResponse> {
        const response = await this.shareClaimRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Submit public widget claim
     */
    async submitPublicClaimWidgetRaw(requestParameters: SubmitPublicClaimWidgetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WidgetSubmitResponse>> {
        if (requestParameters['publicKey'] == null) {
            throw new runtime.RequiredError(
                'publicKey',
                'Required parameter "publicKey" was null or undefined when calling submitPublicClaimWidget().'
            );
        }

        if (requestParameters['widgetSubmitRequest'] == null) {
            throw new runtime.RequiredError(
                'widgetSubmitRequest',
                'Required parameter "widgetSubmitRequest" was null or undefined when calling submitPublicClaimWidget().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/public/widget/{publicKey}/submit`.replace(`{${"publicKey"}}`, encodeURIComponent(String(requestParameters['publicKey']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: WidgetSubmitRequestToJSON(requestParameters['widgetSubmitRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WidgetSubmitResponseFromJSON(jsonValue));
    }

    /**
     * Submit public widget claim
     */
    async submitPublicClaimWidget(requestParameters: SubmitPublicClaimWidgetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WidgetSubmitResponse> {
        const response = await this.submitPublicClaimWidgetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Unlink a contact from a claim
     */
    async unlinkClaimContactRaw(requestParameters: UnlinkClaimContactRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['claimId'] == null) {
            throw new runtime.RequiredError(
                'claimId',
                'Required parameter "claimId" was null or undefined when calling unlinkClaimContact().'
            );
        }

        if (requestParameters['contactId'] == null) {
            throw new runtime.RequiredError(
                'contactId',
                'Required parameter "contactId" was null or undefined when calling unlinkClaimContact().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/claims/{claimId}/contacts/{contactId}`.replace(`{${"claimId"}}`, encodeURIComponent(String(requestParameters['claimId']))).replace(`{${"contactId"}}`, encodeURIComponent(String(requestParameters['contactId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Unlink a contact from a claim
     */
    async unlinkClaimContact(requestParameters: UnlinkClaimContactRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.unlinkClaimContactRaw(requestParameters, initOverrides);
    }

    /**
     * Unlink an organization from a claim
     */
    async unlinkClaimOrganizationRaw(requestParameters: UnlinkClaimOrganizationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['claimId'] == null) {
            throw new runtime.RequiredError(
                'claimId',
                'Required parameter "claimId" was null or undefined when calling unlinkClaimOrganization().'
            );
        }

        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling unlinkClaimOrganization().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/claims/{claimId}/organizations/{organizationId}`.replace(`{${"claimId"}}`, encodeURIComponent(String(requestParameters['claimId']))).replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Unlink an organization from a claim
     */
    async unlinkClaimOrganization(requestParameters: UnlinkClaimOrganizationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.unlinkClaimOrganizationRaw(requestParameters, initOverrides);
    }

    /**
     * When addressType is provided, only the specific link with that address type is removed. When omitted, all links between the claim and property are removed. 
     * Unlink a property from a claim
     */
    async unlinkClaimPropertyRaw(requestParameters: UnlinkClaimPropertyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['claimId'] == null) {
            throw new runtime.RequiredError(
                'claimId',
                'Required parameter "claimId" was null or undefined when calling unlinkClaimProperty().'
            );
        }

        if (requestParameters['propertyId'] == null) {
            throw new runtime.RequiredError(
                'propertyId',
                'Required parameter "propertyId" was null or undefined when calling unlinkClaimProperty().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['addressType'] != null) {
            queryParameters['addressType'] = requestParameters['addressType'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/claims/{claimId}/properties/{propertyId}`.replace(`{${"claimId"}}`, encodeURIComponent(String(requestParameters['claimId']))).replace(`{${"propertyId"}}`, encodeURIComponent(String(requestParameters['propertyId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * When addressType is provided, only the specific link with that address type is removed. When omitted, all links between the claim and property are removed. 
     * Unlink a property from a claim
     */
    async unlinkClaimProperty(requestParameters: UnlinkClaimPropertyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.unlinkClaimPropertyRaw(requestParameters, initOverrides);
    }

    /**
     * Update a claim by id
     */
    async updateClaimRaw(requestParameters: UpdateClaimOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimDetailed>> {
        if (requestParameters['claimId'] == null) {
            throw new runtime.RequiredError(
                'claimId',
                'Required parameter "claimId" was null or undefined when calling updateClaim().'
            );
        }

        if (requestParameters['updateClaimRequest'] == null) {
            throw new runtime.RequiredError(
                'updateClaimRequest',
                'Required parameter "updateClaimRequest" was null or undefined when calling updateClaim().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/claims/{claimId}`.replace(`{${"claimId"}}`, encodeURIComponent(String(requestParameters['claimId']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateClaimRequestToJSON(requestParameters['updateClaimRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimDetailedFromJSON(jsonValue));
    }

    /**
     * Update a claim by id
     */
    async updateClaim(requestParameters: UpdateClaimOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimDetailed> {
        const response = await this.updateClaimRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a claim share\'s permissions
     */
    async updateClaimAccessRaw(requestParameters: UpdateClaimAccessOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateClaimAccess200Response>> {
        if (requestParameters['claimId'] == null) {
            throw new runtime.RequiredError(
                'claimId',
                'Required parameter "claimId" was null or undefined when calling updateClaimAccess().'
            );
        }

        if (requestParameters['shareId'] == null) {
            throw new runtime.RequiredError(
                'shareId',
                'Required parameter "shareId" was null or undefined when calling updateClaimAccess().'
            );
        }

        if (requestParameters['updateClaimAccessRequest'] == null) {
            throw new runtime.RequiredError(
                'updateClaimAccessRequest',
                'Required parameter "updateClaimAccessRequest" was null or undefined when calling updateClaimAccess().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/claims/{claimId}/shares/{shareId}`.replace(`{${"claimId"}}`, encodeURIComponent(String(requestParameters['claimId']))).replace(`{${"shareId"}}`, encodeURIComponent(String(requestParameters['shareId']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateClaimAccessRequestToJSON(requestParameters['updateClaimAccessRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdateClaimAccess200ResponseFromJSON(jsonValue));
    }

    /**
     * Update a claim share\'s permissions
     */
    async updateClaimAccess(requestParameters: UpdateClaimAccessOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdateClaimAccess200Response> {
        const response = await this.updateClaimAccessRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const UnlinkClaimPropertyAddressTypeEnum = {
    Loss: 'loss',
    Billing: 'billing',
    Other: 'other'
} as const;
export type UnlinkClaimPropertyAddressTypeEnum = typeof UnlinkClaimPropertyAddressTypeEnum[keyof typeof UnlinkClaimPropertyAddressTypeEnum];
